"use strict";

var _defineProperty = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIntDataType = void 0;

var ethereum_types_1 = require("ethereum-types");

var configured_bignumber_1 = require("../../configured_bignumber");

var blob_1 = require("../abstract_data_types/types/blob");

var constants_1 = require("../utils/constants");

var EncoderMath = require("../utils/math"); // tslint:disable:custom-no-magic-numbers


var UIntDataType = /*#__PURE__*/function (_blob_1$AbstractBlobD) {
  _inherits(UIntDataType, _blob_1$AbstractBlobD);

  var _super = _createSuper(UIntDataType);

  function UIntDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, UIntDataType);

    _this = _super.call(this, dataItem, dataTypeFactory, UIntDataType._SIZE_KNOWN_AT_COMPILE_TIME);

    if (!UIntDataType.matchType(dataItem.type)) {
      throw new Error("Tried to instantiate UInt with bad input: ".concat(dataItem));
    }

    _this._width = UIntDataType._decodeWidthFromType(dataItem.type);
    _this._maxValue = UIntDataType._WIDTH_TO_MAX_VALUE[_this._width];
    return _this;
  }

  _createClass(UIntDataType, [{
    key: "encodeValue",
    value: function encodeValue(value) {
      var encodedValue = EncoderMath.safeEncodeNumericValue(value, UIntDataType._MIN_VALUE, this._maxValue);
      return encodedValue;
    }
  }, {
    key: "decodeValue",
    value: function decodeValue(calldata) {
      var valueBuf = calldata.popWord();
      var value = EncoderMath.safeDecodeNumericValue(valueBuf, UIntDataType._MIN_VALUE, this._maxValue);

      if (this._width === constants_1.constants.NUMBER_OF_BYTES_IN_UINT8) {
        return value.toNumber();
      }

      return value;
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      var defaultValue = UIntDataType._DEFAULT_VALUE;

      if (this._width === constants_1.constants.NUMBER_OF_BYTES_IN_UINT8) {
        return defaultValue.toNumber();
      }

      return defaultValue;
    }
  }, {
    key: "getSignatureType",
    value: function getSignatureType() {
      return "".concat(ethereum_types_1.SolidityTypes.Uint).concat(this._width);
    }
  }], [{
    key: "matchType",
    value: function matchType(type) {
      return UIntDataType._MATCHER.test(type);
    }
  }, {
    key: "_decodeWidthFromType",
    value: function _decodeWidthFromType(type) {
      var matches = UIntDataType._MATCHER.exec(type);

      var width = matches !== null && matches.length === 2 && matches[1] !== undefined ? parseInt(matches[1], constants_1.constants.DEC_BASE) : UIntDataType._DEFAULT_WIDTH;
      return width;
    }
  }]);

  return UIntDataType;
}(blob_1.AbstractBlobDataType);

exports.UIntDataType = UIntDataType;
UIntDataType._MATCHER = RegExp('^uint(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256){0,1}$');
UIntDataType._SIZE_KNOWN_AT_COMPILE_TIME = true;
UIntDataType._MAX_WIDTH = 256;
UIntDataType._DEFAULT_WIDTH = UIntDataType._MAX_WIDTH;
UIntDataType._MIN_VALUE = new configured_bignumber_1.BigNumber(0);
UIntDataType._DEFAULT_VALUE = new configured_bignumber_1.BigNumber(0);
UIntDataType._WIDTH_TO_MAX_VALUE = Object.assign.apply(Object, [{}].concat(_toConsumableArray(_toConsumableArray(new Array(32)).map(function (_x, i) {
  var width = (i + 1) * 8;
  return _defineProperty({}, width, new configured_bignumber_1.BigNumber(2).exponentiatedBy(width).minus(1));
}))));